import { version } from "os";
import { showAlert } from "../../promptMessages/PromptMessages";
import { fileSourceMapping } from "../config/ConversionConfigMapping";
import { ALERTICON, ALERTMSG } from "../enums";

export const isSupportedFileType = (ext: string) =>
  ["csv", "xls", "xlsx", "txt", "TXT"].includes(ext);

export const processFileSource = (
  fileSource: string,
  json: any[],
  selectedCurrency?: string
) => {
  const mapping = fileSourceMapping[fileSource];
  if (!mapping) return [];

  return json.map((data) => {
    const amount = mapping.amount(data);

    return {
      refno: mapping.refno(data),
      customerId: "",
      sndrFName: mapping.sndrFName(data),
      sndrMName: mapping.sndrMName(data),
      sndrLName: mapping.sndrLName(data),
      sndrBusinessName: mapping.sndrBusinessName
        ? mapping.sndrBusinessName(data)
        : "",
      sndrContactNo: mapping.sndrContactNo(data),
      sndrCity: "",
      sndrProvince: "",
      rcvrFName: mapping.rcvrFName(data),
      rcvrMName: mapping.rcvrMName(data),
      rcvrLName: mapping.rcvrLName(data),
      rcvrContactNo: mapping.rcvrContactNo(data),
      rcvrCity: "",
      rcvrProvince: "",
      origCurrency: selectedCurrency,
      origPrincipalAmount: amount,
      origTotalAmount: 0,
      destCurrency: selectedCurrency,
      destPrincipalAmount: amount,
      destTotalAmount: 0,
      rcvrMisc: mapping.others ? mapping.others(data) : "",
    };
  });
};

export const constructPayload = (
  sendDetails: any[],
  userInfo: any,
  username: string,
  batchNo: string,
  totalPrincipal: number,
  fileSource: string,
  partnersId: string,
  fileVersion?: string
) => ({
  payload: {
    sendBulkInfo: sendDetails,
    userId: username,
    branchId: userInfo?.partnersId?.toString(),
    branchName: userInfo?.partnersName,
    partnersId,
    userFName: userInfo?.userFName,
    userMName: userInfo?.userMName,
    userLName: userInfo?.userLName,
    batchNumber: batchNo?.toString() || "",
    totalDestPrincipalAmount: totalPrincipal,
    fileSource: fileSource || "",
    version: fileVersion || "",
  },
});

export const handleValidationResponse = (
  response: any,
  batchNo: string,
  partnersId: string,
  userInfo: any,
  username: string,
  setFunctions: {
    setNewJsonData: Function;
    setTotal: Function;
    setTotalCharges: Function;
    setTotalPrincipalAmount: Function;
    setUpload: Function;
    setIsValid: Function;
    setRequestData: Function;
    setUploading: Function;
    findPartnerNameById: Function;
    successAlert: Function;
    SomethingAlert: Function;
  },
  themeColors: {
    themeBackground: string;
    customColor: string;
    themeTextColor: string;
  }
) => {
  const {
    respMsg: respMsgv,
    respCode: respCodev,
    totalOrigFee,
    totalOrigPrincipal,
    totalAmount,
    list,
  } = response.data;

  const {
    setNewJsonData,
    setTotal,
    setTotalCharges,
    setTotalPrincipalAmount,
    setUpload,
    setIsValid,
    setRequestData,
    setUploading,
    findPartnerNameById,
    successAlert,
    SomethingAlert,
  } = setFunctions;

  const { themeBackground, customColor, themeTextColor } = themeColors;

  setNewJsonData(list);

  setTotal(totalAmount);

  setTotalCharges(totalOrigFee);

  setTotalPrincipalAmount(totalOrigPrincipal);

  setUpload(true);

  if (respCodev === 2000) {
    setIsValid(true);

    setRequestData({
      payload: {
        sendValidatedInfo: list,
        userId: username,
        branchId: userInfo?.partnersId.toString(),
        branchName: userInfo?.partnersName,
        partnersId: partnersId,
        userFName: userInfo?.userFName,
        userMName: userInfo?.userMName,
        userLName: userInfo?.userLName,
        batchNumber: batchNo?.toString(),
        totalDestPrincipalAmount: totalAmount,
      },
    });

    setUploading(false);

    findPartnerNameById(Number(partnersId));

    successAlert(
      ALERTMSG.VALIDATED,
      "",
      ALERTICON.SUCCESS,
      themeBackground,
      customColor,
      themeTextColor
    );
  } else {
    setUploading(false);

    setUpload(false);

    SomethingAlert(
      ALERTMSG.SOMEWENTWRONG,
      `${respMsgv} (code ${respCodev})`,
      ALERTICON.ERR,
      batchNo?.toString(),
      themeBackground,
      customColor,
      themeTextColor
    );
  }
};

export const handleConversionError = (
  error: any,
  setIsConverting: Function,
  themeColors: {
    themeBackground: string;
    customColor: string;
    themeTextColor: string;
  }
) => {
  const { themeBackground, customColor, themeTextColor } = themeColors;

  showAlert(
    ALERTMSG.SOMEWENTWRONG,
    error,
    "error",
    customColor,
    themeBackground,
    themeTextColor
  );

  setIsConverting(false);
};
